import {Paper, Typography} from "@mui/material";
import {useParams} from "@tanstack/react-router";
import {useEffect, useMemo, useState} from "react";
import {
    DisplayCartReceipt,
    fetchData,
    type ReceiptCart,
} from "@/components/Cart/DisplayCartReceipt.tsx";
import CircularLoadingIndicator from "@/components/CircularLoadingIndicator.tsx";
import {useUser} from "@/components/Providers/JWTProvider.tsx";
import StandardPage from "@/components/StandardPage.tsx";

const CartReceipt = () => {
    const [cart, setCart] = useState<ReceiptCart | null>(null);
    const [error, setError] = useState<boolean>(false);
    const {cartId} = useParams({strict: false});
    const {user} = useUser();

    const displayName = useMemo(() => {
        if (user && "nameFirst" in user) {
            return `${user.nameFirst} ${user.nameLast} - ${user.studentId}`;
        }
        if (user && "displayName" in user) {
            return `${user.displayName} - ${user.employeeID}`;
        }
    }, [user]);

    useEffect(() => {
        if (!(user?.apiFetch && cartId)) {
            return;
        }
        fetchData(user.apiFetch, cartId)
            .then(data => {
                if (!data) {
                    setError(true);
                } else if (data.status !== "PAID") {
                    setError(true);
                } else {
                    setCart(data);
                }
            })
            .catch(error => {
                console.error(error);
                setError(true);
            });
    }, [cartId, user?.apiFetch]);

    return (
        <StandardPage>
            <Paper
                elevation={3}
                sx={{
                    width: "100%",
                    p: 2,
                    overflowY: "auto",
                    backgroundColor: "#fff",
                    mb: 2,
                    borderRadius: 1,
                }}
            >
                {displayName && (
                    <Typography variant="h6" sx={{pb: 2}}>
                        Cart For {displayName}
                    </Typography>
                )}
                {!(cart || error) && <CircularLoadingIndicator />}
                {error && <Typography>There was an error loading the cart</Typography>}
                {cart && <DisplayCartReceipt cart={cart} />}
            </Paper>
        </StandardPage>
    );
};

export default CartReceipt;
